var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenuSites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 11.6739C16.902 12.2586 19 13.5941 19 15.148C19 17.2409 15.1944 18.9375 10.5 18.9375C5.80558 18.9375 2 17.2409 2 15.148C2 13.5941 4.09796 12.2586 7.1 11.6739M10.5 14.727V7.99013M10.5 7.99013C11.9083 7.99013 13.05 6.85906 13.05 5.46382C13.05 4.06857 11.9083 2.9375 10.5 2.9375C9.09167 2.9375 7.95 4.06857 7.95 5.46382C7.95 6.85906 9.09167 7.99013 10.5 7.99013Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSites);
export default __webpack_public_path__ + "static/media/menu-sites.68d364272e8d7b800fc2e910980926cd.svg";
export { ForwardRef as ReactComponent };